import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PhotoStoryPage } from './photo-story.page';

const routes: Routes = [
  {
    path: '',
    component: PhotoStoryPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PhotoStoryPageRoutingModule {}
